import React from "react";

// Shareable flyer page: when the flyer is sent electronically the QR can't be
// scanned, so the whole flyer (and the CTA) is a tappable link to /help.
const FlyerPage = () => {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center px-4 py-8"
      style={{ background: "radial-gradient(circle at 50% 0%, #12233f 0%, #0a1628 55%, #060e1c 100%)" }}
      data-testid="flyer-page"
    >
      <a
        href="/help"
        className="group block w-full max-w-[520px] rounded-3xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:scale-[1.01]"
        style={{ border: "1px solid rgba(201,168,76,0.45)", boxShadow: "0 30px 80px -25px rgba(0,0,0,0.8), 0 0 0 1px rgba(201,168,76,0.12)" }}
        data-testid="flyer-image-link"
        aria-label="Open the Patient Line"
      >
        <img
          src="/patient-line-flyer.png"
          alt="J.House of Secretary — The Patient Line flyer"
          className="w-full h-auto block select-none"
          draggable={false}
        />
      </a>

      <a
        href="/help"
        className="mt-7 inline-flex flex-col items-center gap-1 py-4 px-10 rounded-2xl font-bold uppercase tracking-[0.16em] text-center transition hover:-translate-y-0.5 hover:shadow-[0_18px_45px_-10px_rgba(201,168,76,0.75)]"
        style={{
          background: "linear-gradient(180deg, #d4b661 0%, #c9a84c 50%, #a17f2f 100%)",
          color: "#0a1628",
          border: "1px solid rgba(201,168,76,0.9)",
          boxShadow: "0 8px 24px -6px rgba(201,168,76,0.55), inset 0 1px 0 rgba(255,255,255,0.4)",
          fontFamily: "Georgia, serif",
        }}
        data-testid="flyer-cta-button"
      >
        <span className="text-base md:text-lg">Πατήστε εδώ για βοήθεια</span>
        <span className="text-[11px] font-semibold tracking-[0.22em] opacity-80">TAP HERE FOR HELP</span>
      </a>

      <p className="mt-5 text-slate-400 text-xs md:text-sm text-center max-w-sm" data-testid="flyer-hint">
        Πατήστε στην αφίσα ή στο κουμπί για να ανοίξετε τη «Γραμμή του Ασθενή».
      </p>

      <div className="mt-8 flex flex-col items-center" data-testid="flyer-qr-section">
        <p className="text-gold text-sm font-semibold mb-3" style={{ fontFamily: "Georgia, serif" }}>
          Σαρώστε το QR για τη Γραμμή του Ασθενή
        </p>
        <img
          src="/patient-line-qr.png"
          alt="QR code — The Patient Line"
          className="w-56 h-56 md:w-64 md:h-64 select-none"
          draggable={false}
          data-testid="flyer-qr-image"
        />
        <a
          href="/patient-line-qr.png"
          download="patient-line-qr.png"
          className="mt-4 inline-flex items-center gap-2 py-2.5 px-6 rounded-xl text-sm font-semibold transition hover:-translate-y-0.5"
          style={{ background: "rgba(201,168,76,0.12)", color: "#d4b661", border: "1px solid rgba(201,168,76,0.5)" }}
          data-testid="flyer-qr-download"
        >
          ⬇ Λήψη QR code
        </a>
      </div>
    </div>
  );
};

export default FlyerPage;
